import React, { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebase';
import FloatingSidebarButton from '../../components/FloatingSidebarButton/FloatingSidebarButton';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { useLanguage } from '../../contexts/LanguageContext'; // ⬅️ add
import './Chat.css';

const Chat = () => {
  const [userProfile, setUserProfile] = useState(null);
  const navigate = useNavigate();
  const { translations: t } = useLanguage(); // ⬅️ add

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(), async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          setUserProfile(userDoc.data());
        } else {
          setUserProfile({
            name: user.displayName || "No Name",
            profileImage: user.photoURL || "/default-avatar.png",
            email: user.email,
          });
        }
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="chat-page">
      <FloatingSidebarButton userProfile={userProfile} />
      <button
        className="pages-back-btn"
        onClick={() => navigate(-1)}
        aria-label={t.common?.back || "Back"}
        title={t.common?.back || "Back"}
      >
        <FiArrowLeft />
      </button>
      <div className="chat-container">
        <h1>{t.chat?.title || "Chat"}</h1>
        <p>{t.chat?.comingSoon || "Chat functionality coming soon..."}</p>
      </div>
    </div>
  );
};

export default Chat;
